import { createFileRoute } from '@tanstack/react-router';
import { AttendanceItemDetailLayout } from './-components/AttendanceItemDetailLayout';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/items/$componentId/_layout')({
  component: AttendanceItemDetailLayout
});